import { Link } from "react-router-dom";

const Missing = () => {
  return (
    <div className="p-96 text-center">
      <h1 className="text-3xl">Esta página no existe</h1>
      <div className="underline text-blue-400 p-10">
        <Link to="/">Ve de vuelta al inicio</Link>
      </div>
    </div>
  )
}

export default Missing
